<template>
    <div v-if="visible" class="modal-mask modal-transition">
        <div class="modal-container">
            <h1>Blocked GEOs for {{methodName}}</h1>

            <div style="width: 25%">
                <input
                        type="text"
                        class="search-box"
                        placeholder="Type country..."
                        v-model="searchQuery"
                />
            </div>

            <div id="table-wrapper">
                <div id="table-scroll">
                    <div v-if="filteredCountries.length" class="table-geo">
                        <b-col cols="6" style="float: left" v-for="(country, index) in filteredCountries" :key="index">
                            <p class="countrycheckbox">
                                <input
                                        :id="`countryCheckbox-${index}`"
                                        type="checkbox"
                                        :checked="isBanned(country.code)"
                                        @change="toggleCountry(country.code)"
                                >
                                <label :for="`countryCheckbox-${index}`">
                                    {{ country.name }} ({{ country.code }})
                                </label>
                            </p>
                        </b-col>
                    </div>
                </div>
            </div>

            <v-row class="text-center">
                <b-col cols="12">
                    <div class="allow-ban-all text-left">
                        <div><b-form-text><b>Allowed:</b> {{ allowedList.join(', ') }}</b-form-text></div>
                        <div><b-form-text><b>Banned:</b> {{ bannedList.join(', ') }}</b-form-text></div>
                    </div>
                </b-col>
            </v-row>

            <v-row class="text-center">
                <v-col cols="12">
                    <div class="allow-ban-all">
                        <b-button variant="light" class="btn-allow-ban-all" @click="allowAll">
                            <i class="far fa-check-circle" data-fa-transform="shrink-1"></i> Allow All GEOs
                        </b-button>
                        <b-button variant="light" class="btn-allow-ban-all" @click="banAll">
                            <i class="far fa-ban" data-fa-transform="shrink-1"></i> Ban All GEOs
                        </b-button>
                    </div>
                </v-col>
            </v-row>
            <v-row class="text-center modal-footer-1" style="margin-top: 20px">
                <v-col cols="12">
                    <div class="d-flex justify-space-between">
                        <v-btn class="btn" @click="close">CANCEL</v-btn>
                        <v-btn color="primary" @click="save">SAVE</v-btn>
                    </div>
                </v-col>
            </v-row>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            allCountries: {
                type: Array,
                required: true
            },
            bannedCountries: {
                type: Array,
                required: true
            },
            methodName: {
                type: String,
                required: true

            }
        },
        data() {
            return {
                visible: false,
                localBanned: [],
                searchQuery: ''
            };
        },
        computed: {
            filteredCountries() {
                if (!this.searchQuery) return this.allCountries
                const q = this.searchQuery.toLowerCase()
                return this.allCountries.filter(c =>
                    c.name.toLowerCase().includes(q) || c.code.toLowerCase().includes(q)
                )
            },
            allowedList() {
                return this.allCountries
                    .map(c => c.code)
                    .filter(code => !this.localBanned.includes(code))
            },
            bannedList() {
                return [...this.localBanned]
            }
        },
        methods: {
            isBanned(code) {
                return this.localBanned.includes(code)
            },
            toggleCountry(code) {
                if (this.isBanned(code)) {
                    this.localBanned = this.localBanned.filter(c => c !== code)
                } else {
                    this.localBanned.push(code)
                }
            },
            allowAll() {
                this.localBanned = []
            },
            banAll() {
                this.localBanned = this.allCountries.map(c => c.code)
            },
            show() {
                this.localBanned = [...this.bannedCountries]
                this.visible = true
            },
            close() {
                this.visible = false
            },
            save() {
                this.visible = false;
                this.$emit('saved', {
                    banned: [...this.localBanned],
                    allowed: this.allowedList
                })
            }
        },
        watch: {
            bannedCountries: {
                immediate: true,
                handler(newVal) {
                    this.localBanned = [...newVal]
                }
            }
        }
    }
</script>

<style lang="sass">
    .modal-mask
        position: fixed
        z-index: 9998
        top: 0
        left: 0
        width: 100vw
        height: 100vh
        background-color: rgba(0, 0, 0, .7)
        display: flex
        align-items: center
        justify-content: center

    .modal-container
        min-width: 60vw
        max-width: 60vw
        max-height: 80vh
        padding: 30px
        background: #fff
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
        overflow: auto
        border-radius: 10px

    .search-box
        box-shadow: 0 0 3px #9cc0d3
        margin-bottom: 15px
        width: 100%
        padding: 8px

    #table-scroll
        height: 220px
        overflow: auto
        padding: 15px
        border: 2px solid #E3EEF4
        border-radius: 7px
        min-height: 215px
        margin-top: 15px

    .allow-ban-all
        margin-top: 10px

    .countrycheckbox
        input[type="checkbox"]
            display: none !important

        input[type=checkbox] + label:before
            display: inline-block
            font-family: "Font Awesome 5 Free"
            font-size: 16px
            content: '\f058'
            color: #2ED47A
            font-weight: 400
            cursor: pointer

        input[type=checkbox]:checked + label:before
            content: "\f05e"
            color: #EB5757
            font-weight: 900
</style>
